import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ArrowRight } from 'lucide-react';
export function FinalCTA() {
  const handlePurchase = () => {
    window.open('https://www.metodolowtox.com/cart/51631184806199:1', '_blank');
  };
  return <section className="py-24 px-6 bg-[#F5F1E8] text-center" data-id="element-19">
      <div className="max-w-2xl mx-auto" data-id="element-20">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-21">
          <h2 className="text-3xl md:text-4xl font-serif text-[#2D2D2D] mb-6" data-id="element-22">
            Your next step
          </h2>
          <p className="text-xl text-[#5A5A5A] mb-10 leading-relaxed" data-id="element-23">
            If you're ready to stop guessing and start running a simple,
            repeatable fragrance-free routine…
          </p>
          <p className="text-lg text-[#2D2D2D] font-medium mb-10" data-id="element-24">
            Get{' '}
            <span className="italic" data-id="element-25">The 14-Day Fragrance-Free Home Reset</span>{' '}
            now and follow the checklist tonight.
          </p>
          <Button onClick={handlePurchase} className="w-full md:w-auto text-lg px-12 py-5" data-id="element-26">
            Download The Reset <ArrowRight className="ml-2 w-5 h-5" data-id="element-27" />
          </Button>
        </motion.div>
      </div>
    </section>;
}